<template>
  <div class="outer-page">
    <navigation class="header"></navigation>
    <div class="page">
      <!-- <div class="back">
            <div class="click-area">
                <img
                    @click="back"
                    src="./images/btn_fanhui.png"
                    srcset="
                        ./images/btn_fanhui@2x.png 2x,
                        ./images/btn_fanhui@3x.png 3x
                    "
                />
            </div>
        </div> -->
      <header>
        <img
          class="logo"
          src="../user/images/logo.png"
          srcset="
                    ../user/images/logo@2x.png 2x,
                    ../user/images/logo@3x.png 3x
                "
        />
        <div class="rule-button" @click="goActivityRule">
          <span class="rule-button-icon">?</span>活动规则
        </div>
      </header>
      <section>
        <img
          class="section-title"
          src="./images/img_100.png"
          srcset="
                        ./images/img_100@2x.png 2x,
                        ./images/img_100@3x.png 3x
                    "
        />

        <template v-if="credit_success">
          <p class="highlight font32 center">
            您已获得{{creditLimit | currency}}额度，
          </p>
          <p class="highlight font32 center" style="height: 0px;">
            快去提现吧！
          </p>
        </template>
        <template v-else-if="status === 'PRE_PROVIDE'">
          <p class="highlight font32 center">
            提取你的现金红包
          </p>
          <p class="font22 center" style="margin-top:10px; height: 0px;">
            天美贷，说到做到
          </p>
        </template>
        <template v-else-if="['RECEIVED', 'USING', 'USED'].includes(status)">
          <p class="highlight font32 center" style="margin-top: 13px">
            抽中了红包
          </p>
        </template>

        <div class="main">
          <template v-if="credit_success">
            <img
              class="main-pic qianbao"
              src="./images/img_qianbao.png"
              srcset="
                            ./images/img_qianbao@2x.png 2x,
                            ./images/img_qianbao@3x.png 3x
                        "
            />
          </template>
          <template
            v-else-if="
              [
                'OCR',
                'INFO',
                'CREDIT',
                'CREDIT_REVIEW'
              ].includes(nextStep)
            "
          ><img
            class="main-pic uncredit"
            src="./images/main_01.png"
            srcset="
                            ./images/main_01@2x.png 2x,
                            ./images/main_01@3x.png 3x
                        "
          /></template>
          <template v-else-if="status === 'PRE_PROVIDE'"><img
            @click="open"
            v-stat="{ id: 50004, args: { status: this.plan } }"
            class="main-pic hongbao"
            src="./images/hongbao_guan.png"
            srcset="
                            ./images/hongbao_guan@2x.png 2x,
                            ./images/hongbao_guan@3x.png 3x
                        "
          />
            <img
              @click="open"
              v-stat="{ id: 50004, args: { status: this.plan } }"
              class="hand"
              src="./images/hand.png"
              srcset="
                            ./images/hand@2x.png 2x,
                            ./images/hand@3x.png 3x
                        "
          /></template>
          <template v-else-if="status === 'RECEIVED'"><img
            class="main-pic hongbao-kai"
            src="./images/hongbao_kai.png"
            srcset="
                            ./images/hongbao_kai@2x.png 2x,
                            ./images/hongbao_kai@3x.png 3x
                        "
          />
            <div class="amount">
              {{ couponDetail.discountValue | currency }}
              <span class="font28">元</span>
            </div>
            <nd-button
              class="main-button"
              :disabled="false"
              @click="accept"
              v-stat="{ id: 50005, args: { status: this.plan } }"
          >红包提现</nd-button></template>
          <template v-else-if="status === 'USED' || status === 'USING'">
            <img
              class="main-pic hongbao-kai"
              src="./images/hongbao_kai.png"
              srcset="
                            ./images/hongbao_kai@2x.png 2x,
                            ./images/hongbao_kai@3x.png 3x
                        "
            />
            <div class="amount">
              {{ couponDetail.discountValue | currency }}
              <span class="font28">元</span>
            </div>
            <nd-button class="main-button disabled">您已提现</nd-button>
          </template>
        </div>

        <div class="container" :class="{ cannot: credit_success }">
          <template v-if="credit_success">
            <!-- <template
                        v-if="
                            ['LOAN_AUDIT', 'LOANING', 'LOAN'].includes(nextStep)
                        "
                    > -->
            <div
              class="button"
              @click="navigateTo(nextNode)"
              v-stat="{ id: 50003, args: { status: this.plan } }"
            >
              立即提现
            </div>
          </template>
          <template
            v-else-if="
              ['OCR', 'INFO', 'CREDIT', 'CREDIT_REVIEW'].includes(
                nextStep
              )
            "
          >
            <div
              class="button"
              @click="navigateTo(nextNode)"
              v-stat="{ id: 50002, args: { status: this.plan } }"
            >
              立即领取额度
          </div></template>
          <template v-if="status === 'USED' || status === 'USING'"><div class="tip">
            现金预计2个工作日到账，任何疑问请详询天美贷客服
          </div></template>
          <p class="title" :class="{ cannot: credit_success }">
            怎么任性，怎么玩
          </p>
          <template v-if="credit_success">
            <p class="longer">
              持续关注天美贷，更多精彩活动等你来参与!
            </p>
            <img
              class="huodong"
              src="./images/img_huodong.png"
              srcset="
                            ./images/img_huodong@2x.png 2x,
                            ./images/img_huodong@3x.png 3x
                        "
            />
          </template>
          <template v-else>
            <p>
              活动期间天美贷申请通过率是平时的<span class="highlight">两倍，资金充足，等你来提现！</span>只要授信申请被拒绝，秒获红包现金。
            </p>
            <img
              class="pei"
              src="./images/img_pei.png"
              srcset="
                            ./images/img_pei@2x.png 2x,
                            ./images/img_pei@3x.png 3x
                        "
            />
            <div class="text">
              <span>授信未通过我赔付</span>
            </div>
          </template>
        </div>
      </section>
      <footer>活动所有解释权归天美贷所有</footer>
      <nd-dialog
        v-model="popup"
        class="dialog"
        :footer="false"
        close-btn
        @close="closeHandler"
      >
        <div class="popup-content">
          <img class="pei" src="./images/chouzhong.gif" />
          <p class="text">抽中了红包</p>
          <p class="amount">
            {{ couponDetail.discountValue | currency }}
            <span class="font28">元</span>
          </p>
          <nd-button
            class="button"
            @click="accept"
            v-stat="{ id: 50007, args: { status: this.plan } }"
          >
            开心收下
          </nd-button>
        </div>
      </nd-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { judgeClientSystem } from '@/assets/utils'
export default {
  data () {
    return {
      popup: false,
      plan: '',
      status: '',
      activeType: this.$route.query.activeType || 'PAY_IF_REFUSE_NEW',
      loanPlatform: this.$route.query.loanPlatform,
      couponDetail: {},
      nextStep: '',
      relationId: '',
      credit_success: false,
      reason: '',
      activeStartTime: 0,
      activeEndTime: 0,
      autoOpen: this.$route.query.open,
      couponId: null
    }
  },
  watch: {
    popup (value) {
      this.$report({
        id: 50008,
        args: {
          visible: value ? 1 : 0,
          status: this.plan
        }
      })
    }
  },
  async mounted () {
    await this.getActiveDetail()
    if (this.couponId) await this.getCouponDetail()
    if (this.autoOpen && this.status === 'PRE_PROVIDE') this.open()
    this.$bus.$emit('ready')
  },

  computed: {
    ...mapState('user', {
      creditLimit: (state) => state.quotaInfo.creditLimit
    }),
    nextNode () {
      switch (this.nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr' }
        case 'INFO':
          return { h5: '/authentication/base', native: 'basic_info' }
        case 'CREDIT':
          return {
            h5: '/authentication/base',
            native: 'basic_info'
          }
        case 'CREDIT_REVIEW':
          return {
            h5: `/authentication/result?applyNo=${this.relationId}`
          }
        case 'CREDIT_SUCCESS':
          return { h5: '/withdraw/index', native: 'withdraw' }
        // case 'LOAN_AUDIT':
        //     return {
        //         h5: `/withdraw/result?loanApplyNo=${this.relationId}`
        //     }
        // case 'LOANING':
        //     return {
        //         h5: `/withdraw/result?loanApplyNo=${this.relationId}`
        //     }
        // case 'LOAN':
        //     return { h5: '/withdraw/index', native: 'withdraw' }
        default:
          return { h5: '/authentication/id', native: 'ocr' }
      }
    }
  },
  methods: {
    ...mapActions('activities', [
      'qualificationCouponX',
      'couponDetailX',
      'drawCouponX',
      'couponDetailX',
      'activeCouponX'
    ]),
    ...mapActions('user', ['getLimitX']),

    navigateTo (path) {
      // console.log(path)
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    back () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.back()
      }
    },
    goActivityRule () {
      this.$report({
        id: 50006
      })
      this.$router.push(
        `/activities/rule?start=${this.activeStartTime}&end=${this.activeEndTime}`
      )
    },
    async open () {
      const res = await this.activeCouponX({
        activeType: this.activeType,
        couponRecordId: this.couponDetail.couponRecordId,
        relationId: this.couponDetail.relationId
      })
      if (res.success) {
        this.popup = true
        this.getCouponDetail()
      }
    },
    accept () {
      this.$report({
        id: 50010,
        args: {
          status: this.plan
        }
      })
      this.$router.push(
        `/activities/band?couponRecordId=${this.couponDetail.couponRecordId}&plan=${this.plan}`
      )
    },
    async getCouponDetail () {
      const res = await this.couponDetailX({
        activeType: this.activeType,
        couponRecordId: this.couponId
      })
      this.couponDetail = res.data || {}
      // const date = new Date(this.couponDetail.endTime)
      // this.couponDetail.endTime = date.setDate(date.getDate() + 1)
      this.status = this.couponDetail.status
      if (this.status === 'PRE_PROVIDE') {
        this.$report({
          id: 50001,
          args: {
            status: 4,
            position: this.plan
          }
        })
      }
      if (this.status === 'RECEIVED') {
        this.$report({
          id: 50001,
          args: {
            status: 5,
            position: this.plan
          }
        })
      }
      if (this.status === 'USED' || this.status === 'USING') {
        this.$report({
          id: 50001,
          args: {
            status: 3,
            position: this.plan
          }
        })
      }
    },
    async getActiveDetail () {
      const res = await this.qualificationCouponX({
        activeType: this.activeType
      })
      if (res.data[0]) {
        this.plan = res.data[0].couponDetailType
        this.qualification = res.data[0].qualification
        // 如果提现成功了就没资格
        if (res.data[0].nextStep === 'CREDIT_SUCCESS') {
          this.credit_success = true
          this.getLimitX({ loanPlatform: 'TMD' })
        }
        this.reason = res.data[0].desc
        this.nextStep = res.data[0].nextStep
        this.activeStartTime = res.data[0].activeStartTime
        this.activeEndTime = res.data[0].activeEndTime
        this.relationId = res.data[0].relationId
        this.couponId = res.data[0].couponRecordId
      }

      switch (this.nextStep) {
        case 'OCR':
        case 'INFO':
        case 'CREDIT':
          this.$report({
            id: 50001,
            args: {
              status: 1,
              position: this.plan
            }
          })
          break
        case 'LOAN':
          this.$report({
            id: 50001,
            args: {
              status: 2,
              position: this.plan
            }
          })
          break
      }
    },

    closeHandler () {
      this.$report({
        id: 50009,
        args: {
          status: this.plan
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.font32 {
    font-size: 32px;
}
.font22 {
    font-size: 22px;
}
.font28 {
    font-size: 28px;
}
.highlight {
    color: #ffdd69;
}
.center {
    text-align: center;
}
.page {
    background-color: #5267c7;
    color: #fff;
    font-size: 28px;
    overflow: hidden;
    .back {
        height: 76px;
        margin-top: 50px;
        margin-left: 55px;
        .click-area {
            position: fixed;
            z-index: 9999;
            top: 50px;
            left: 35px;
            width: 88px;
            height: 76px;
            overflow: hidden;
            > img {
                display: block;
                margin: 20px auto;
                width: 48px;
                height: 36px;
            }
        }
    }
    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        margin-top: 30px;
        .logo {
            width: 70px;
            height: 70px;
            margin-left: 35px;
        }
        .rule-button {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            > span {
                width: 32px;
                height: 32px;
                line-height: 32px;
                margin-right: 5px;
                background-color: rgba(255, 255, 255, 1);
                color: #5267c7;
                font-weight: 600;
                border-radius: 50%;
                text-align: center;
            }
        }
    }
    section {
        .section-title {
            display: block;
            width: 550px;
            height: 269px;
            margin: 75px auto 40px;
        }
        .main {
            position: relative;
            width: 750px;
            height: 563px;
            margin-top: 15px;
            background: url('./images/bg_center@2x.png') center center no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            .amount {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 360px;
                font-size: 70px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: rgba(255, 69, 57, 1);
            }
            .main-button {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 100px;
                width: 280px;
                height: 80px;
                line-height: 80px;
                background: rgba(255, 221, 166, 1);
                border-radius: 40px;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(186, 113, 20, 1);
                &.disabled {
                    background: rgba(221, 221, 221, 1);
                    color: #fff;
                }
            }
            .uncredit {
                width: 520px;
                height: 460px;
            }
            .qianbao {
                width: 440px;
                height: 420px;
            }
            .hongbao {
                width: 380px;
                height: 460px;
            }
            .hongbao-kai {
                width: 380px;
                height: 505px;
            }
            .hand {
                @keyframes hand {
                    0% {
                        transform: translateY(-15px);
                    }
                    50% {
                        transform: translateY(15px);
                    }
                    100% {
                        transform: translateY(-15px);
                    }
                }
                position: absolute;
                right: 220px;
                bottom: 117px;
                width: 134px;
                height: 147px;
                animation: hand 1.5s ease infinite;
            }
            .main-pic {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 20px;
            }
        }
        .container {
            position: relative;
            width: 640px;
            height: 740px;
            margin: auto;
            padding: 0 60px;
            border-radius: 0 0 30px 30px;
            background-color: #363c75;
            overflow: hidden;
            &.cannot {
                height: 890px;
            }
            .tip {
                position: absolute;
                top: 66px;
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
                font-size: 24px;
                text-align: center;
            }
            .button {
                @keyframes zoom {
                    0% {
                        transform: translateX(-50%) scale(1);
                    }
                    50% {
                        transform: translateX(-50%) scale(0.9);
                    }
                    100% {
                        transform: translateX(-50%) scale(1);
                    }
                }
                position: absolute;
                top: 40px;
                left: 50%;
                transform: translateX(-50%);
                width: 520px;
                height: 100px;
                line-height: 100px;
                font-size: 40px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                text-align: center;
                background: url('./images/bg_btn.png') center center no-repeat;
                background-size: 100% 100%;
                animation: zoom 1s infinite;
            }
            .title {
                position: absolute;
                top: 185px;
                left: 50%;
                transform: translateX(-50%);
                width: 316px;
                height: 50px;
                line-height: 50px;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                text-align: center;
                &::before {
                    position: absolute;
                    content: '';
                    top: 9px;
                    left: -93px;
                    width: 93px;
                    height: 32px;
                    background: url('./images/dosh_right@2x.png') center center
                        no-repeat;
                    background-size: 100% 100%;
                }
                &::after {
                    position: absolute;
                    content: '';
                    top: 9px;
                    right: -93px;
                    width: 93px;
                    height: 32px;
                    background: url('./images/dosh_left@2x.png') center center
                        no-repeat;
                    background-size: 100% 100%;
                }
                &.cannot {
                    top: 245px;
                }
            }
            .pei {
                position: absolute;
                top: 440px;
                left: 50%;
                transform: translateX(-50%);
                width: 512px;
                height: 150px;
            }
            .huodong {
                position: absolute;
                top: 453px;
                left: 50%;
                transform: translateX(-50%);
                width: 512px;
                height: 377px;
            }
            > p {
                position: absolute;
                top: 264px;
                left: 50%;
                transform: translateX(-50%);
                width: 532px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 40px;
                &.longer {
                    width: 560px;
                    top: 324px;
                }
            }
            .text {
                position: absolute;
                top: 440px;
                left: 50%;
                transform: translateX(-50%);
                width: 512px;
                height: 150px;
                padding-left: 200px;
                line-height: 150px;
                > span {
                    text-align: center;
                    font-size: 30px;
                }
            }
        }
    }
    footer {
        width: 750px;
        height: 220px;
        font-size: 22px;
        color: rgba(221, 221, 221, 1);
        text-align: center;
        background: url('./images/bg_bottom.png') center center no-repeat;
        background-size: 100% 100%;
        padding-top: 20px;
        margin-top: 60px;

    }
    .popup-content {
        color: #333;
        text-align: center;
        > img {
            display: block;
            width: 230px;
            height: 230px;
            margin: 70px auto 14px;
        }
        .text {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }
        .amount {
            margin-top: 8px;
            font-size: 70px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: rgba(255, 69, 57, 1);
            .font28 {
                color: #333;
            }
        }
        .button {
            width: 440px;
            height: 80px;
            line-height: 80px;
            margin: 85px auto 110px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }
    }
}
</style>
